import { AppListenerMiddleware } from "@src/store/rootState";
import { getAiChatSessionId } from "@src/store/slices/aiChat";
import { experienceBuilderAiSlice } from "@src/store/slices/experienceBuilder/ai/slice";
import { mpVivChatToggled } from "@src/utils/mixpanel";
import { selectedExperience } from "@src/store/slices/experiences";

const { setOpen } = experienceBuilderAiSlice.actions;

export function setupMixPanelListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: setOpen,
    effect: async (action, { getState }) => {
      const opened = action.payload;
      const experience = selectedExperience(getState());
      const chatId = getAiChatSessionId(getState());
      mpVivChatToggled({
        experienceId: experience?.id,
        chatId,
        origin: experienceBuilderAiSlice.selectors.getChatOrigin(getState()),
        opened,
      });
    },
  });
}
